<template>
  <div>
    <tc-v-btn
      id="button-instant-checkout"
      color="accent"
      class="my-5 text-capitalize"
      x-large
      block
      :disabled="isDisabled"
      :aria-label="$t('reward-instant-checkout')"
      tabindex="0"
      @click="instantCheckout"
    >
      {{ $t('reward-instant-checkout') }}
    </tc-v-btn>

    <div class="orWrapper">
      <div class="horizontalDivider" />
      <div class="orStyling">
        {{ $t('reward-variable-or-verbiage') }}
      </div>
      <div class="horizontalDivider" />
    </div>

    <div class="white mt-5">
      <tc-v-btn
        id="button-reward-add"
        color="primary"
        class="text-capitalize"
        x-large
        text
        block
        :disabled="isDisabled"
        :aria-label="$t('reward-add-to-cart')"
        tabindex="0"
        @click="checkout"
      >
        {{ $t('reward-add-to-cart') }}
      </tc-v-btn>
    </div>
  </div>
</template>

<script>
import { checkoutButtonEvents } from '@/components/reward/details/reward-details-constants'

export default {
  name: 'CheckoutButtons',
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkout () {
      this.$emit(checkoutButtonEvents.CHECKOUT)
    },
    instantCheckout () {
      this.$emit(checkoutButtonEvents.INSTANT_CHECKOUT)
    }
  }
}
</script>

<style lang="scss" scoped>

.orWrapper {
  display: flex;
  position: relative;
  margin-top: 25px;
}

.horizontalDivider {
  height: 3px;
  background-color: #bbb;
  width: 40%;
  transform: translateY(350%);
}

.orStyling {
  width: 20%;
}
</style>
